import React from "react";

import { TextAppearance, TextColor, TextCustom, TextWeight } from "@vw-marketing/us-components";

import { SubtitleAndCTAContainer } from "./styled";

const SubtitleAndCTA = ({
  subtitle,
}: {
  subtitle: string;
}) => {
  return (
    <SubtitleAndCTAContainer>
      <TextCustom
        appearance={TextAppearance.headline200}
        style={{ color: TextColor.primary, fontWeight: TextWeight.bold }}
      >
        {subtitle}
      </TextCustom>
    </SubtitleAndCTAContainer>
  );
}

export default SubtitleAndCTA;